import { useEffect, useRef, useState } from 'react'
import './ReimagineBusinessSection.scss'
import handshakeImg from '../../../../assets/images/landing/ReimagieBusiness/handshake.png'
import safeImg from '../../../../assets/images/landing/ReimagieBusiness/safe.png'
import bulbImg from '../../../../assets/images/landing/ReimagieBusiness/bulb.png'

type TabKey = 'ideology' | 'payment' | 'ai';

const tabs: { key: TabKey; label: string }[] = [
  { key: 'ideology', label: 'Our Ideology' },
  { key: 'payment', label: 'Your Payment, Always Safe' },
  { key: 'ai', label: 'AI Driven Platform' }
]

const ReimagineBusinessSection = () => {
  const [active, setActive] = useState<TabKey>('ideology')
  const tabRefs = useRef<HTMLButtonElement[]>([])
  const [slider, setSlider] = useState<{ left: number; width: number }>({ left: 0, width: 0 })

  const setRef = (el: HTMLButtonElement | null, index: number) => {
    if (el) tabRefs.current[index] = el
  }

  const updateSlider = () => {
    const index = tabs.findIndex(t => t.key === active)
    const el = tabRefs.current[index]
    if (el) {
      const { offsetLeft, offsetWidth } = el
      setSlider({ left: offsetLeft, width: offsetWidth })
    }
  }

  useEffect(() => {
    updateSlider()
    const onResize = () => updateSlider()
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
    // eslint-disable-next-line
  }, [active])

  return (
    <section className="reimagineSection">
      <div className="reimagineSection__header">
        <h1>
          Reimagine business with <span>Freelancing and AI</span>
        </h1>
        <p className="reimagineSection__sub">
          <strong>GenieGig</strong> offers you the most sophisticated platform
          to work with freelancers
          <br />
          And we mean it!
        </p>
      </div>

      <div className="reimagineTabs">
        <div
          className="reimagineTabs__slider"
          style={{ left: slider.left, width: slider.width }}
        />
        {tabs.map((t) => (
          <button
            key={t.key}
            ref={(el) =>
              setRef(
                el,
                tabs.findIndex((x) => x.key === t.key)
              )
            }
            className={
              active === t.key
                ? "reimagineTabs__tab active"
                : "reimagineTabs__tab"
            }
            onClick={() => setActive(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="reimagineSection__content">
        <div className="reimagineSection__text">
          {active === "ideology" && (
            <>
              <h2>Our Ideology is simple!</h2>
              <p>
                Why pay a fixed price upfront for a project tailored just for
                you? At GenieGig, we believe in{" "}
                <u>transparency, trust, and collaboration</u> from the very
                first conversation.
              </p>
              <ul>
                <li>
                  <b>Connect first</b> — chat directly with freelancers to
                  discuss your ideas and needs.
                </li>
                <li>
                  <b>Negotiate freely</b> — arrive at a price that works for
                  both sides, no surprises.
                </li>
                <li>
                  <b>Clear payment orders</b> — detailed price, delivery time,
                  revisions, deliverables.
                </li>
                <li>
                  <b>Confidence in commitment</b> — pay only once terms are
                  agreed.
                </li>
              </ul>
            </>
          )}

          {active === "payment" && (
            <>
              <h2>Your Payment is Always Safe</h2>
              <p>
                Payments are never sent directly to freelancers upfront. Funds
                are held securely until you receive, review, and approve the
                final delivery.
              </p>
              <ul>
                <li>
                  <b>Protected</b> in escrow until completion and your approval.
                </li>
                <li>
                  <b>Instant refund</b> in case of disputes—no hidden fees.
                </li>
                <li>
                  <b>Transparent process</b> with clear order details.
                </li>
                <li>
                  <b>Peace of mind</b> knowing your investment is safe.
                </li>
              </ul>
            </>
          )}

          {active === "ai" && (
            <>
              <h2>Innovation at the Core of Freelancing</h2>
              <p>
                GenieGig harnesses AI to revolutionize how freelancers and
                clients connect, collaborate, and create value faster than ever.
              </p>
              <ul>
                <li>
                  <b>Smart Talent Discovery</b> — AI optimizes search results and
                  highlights the most relevant, high-rated talent for your
                  project needs.
                </li>
                <li>
                  <b>Accelerated Results</b> — Streamlined, smart workflows get your
                  project from idea to delivery faster than traditional
                  platforms.
                </li>
                <li>
                  <b>Maximized Project Value</b> — A data-driven process ensures your
                  budget delivers the highest quality and most impactful result.
                </li>
              </ul>
            </>
          )}
        </div>

        <div className="reimagineSection__image">
          <img
            src={
              active === "ideology"
                ? handshakeImg
                : active === "payment"
                ? safeImg
                : bulbImg
            }
            alt="section visual"
          />
        </div>
      </div>
    </section>
  );
}

export default ReimagineBusinessSection

